import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Header from '../components/Header'
import { fetchUserData } from 'redux/actions/actions'
import { logout } from 'redux/actions/actions'

class HeaderContainer extends React.Component {

	componentWillMount() {
		const { dispatch } = this.props
		dispatch(fetchUserData())
	}

	render () {
		return <Header {...this.props} />
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		dispatch,
		logout: () => dispatch(logout())
	}
}

const mapStateToProps = state => {
	return {
		email: state.userData.email
	}
}

HeaderContainer.propTypes = {
	dispatch: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer)


// WEBPACK FOOTER //
// ./src/containers/HeaderContainer.js